<template>
	<ht-modal v-if="showModal" @close="closeModal" size="l">
		<template #header
			><h3>{{ $t('new-version') }} {{ version }}</h3></template
		>
		<template #body>
			<!-- <label for="new-feature-list">{{ $t('new-features') }}</label> -->
			<!-- <ul id="new-feature-list">
				<li>{{$t('improved-ribbon-yarn-calculations')}}</li>
			</ul> -->
			<div>
				<button class="buttons" @click="closeModal">{{ $t('close') }}</button>
			</div>
		</template>
	</ht-modal>
</template>

<script>
import HtModal from '@/components/HtModal';

export default {
	name: 'HtNewFeature',
	data() {
		return {
			showModal: false,
		};
	},
	async created() {
		await this.getFirstTimeAccess();
	},
	methods: {
		async getFirstTimeAccess() {
			let firstTimeAccessData;
			let showModal = false;
			try {
				firstTimeAccessData = await this.$storage.getItem('version');
				if (firstTimeAccessData == null || firstTimeAccessData !== this.version) {
					showModal = true;
				}
			} catch (error) {
				console.error(error);
			}
			this.showModal = showModal;
		},
		closeModal() {
			this.showModal = false;
			this.$emit('close');
			this.$storage.setItem('version', this.version).catch(error => {
				console.error(error);
			});
		},
	},
	computed: {
		version() {
			return process.env.VUE_APP_VERSION;
		},
	},
	components: {
		HtModal,
	},
};
</script>
<style>
.buttons {
	width: 100%;
}
</style>
